module.exports = __webpack_public_path__ + "assets/img/icon-style-show.fed4d8c1.png";